import config from "../../configurations";
import React, { useState, useEffect } from "react";
import MaskedInput from "react-text-mask";
import {
  Form,
  Col,
  Button,
  FormText,
  Container,
  Row,
  Collapse,
} from "react-bootstrap";
import tpunit_logo from "../../images/GISC_graphic_TPNRD3.jpg";
import gisc_logo from "../../images/gisc_logo.png";
import tpnrd_logo from "../../images/tpnrd_logo.jpg";
import PasswordPopUp from "../registration/PasswordPopUp";
import Alert from "../common/Alert";
import FluentdHelper from "../../helpers/FluentdHelper";
import {
  DANGER,
  ELECTRIC_PROVIDERS_LIST,
  EMPTY,
  LOG_OUT,
  LOGERROR,
  LOGGING_OUT,
  MC003,
  MC004,
  MC005,
  MC006,
  REGISTERED_USER,
  STATES,
  SUCCESSFUL_REGISTRATION,
} from "../../configurations/Constants";

import {
  SIGNUP_CODE_NOT_VALID,
  USER_EMAIL_REGISTERED,
  MOBILE_NUMBER_REGISTERED,
  ENTER_REQUIRED_INFO,
  UNIQUE_ENTITY_NAME,
  EMAIL_NOT_MATCHING_WITH_CONFIRM_EMAIL,
  MOBILE_NUMBER_NOT_MATCHING_WITH_CONFIRM_MOBILE_NUMBER,
  ENTER_CONFIRM_EMAIL,
  EMAIL_DONT_MATCH,
  ENTER_CONFIRM_MOBILE_NUMBER,
  MOBILE_NUMBERS_DONT_MATCH,
  ERROR_CALLING_FUNCTION,
  SIGNUP_CODE_NEEDED,
  COMPLETE_REGISTRATION,
  ENTER_LAST_NAME,
  ENTER_ONLY_LETTERS,
  EMAIL_IS_INVALID,
  ENTER_MOBILE_NUMBER,
  INVALID_MOBILE_NUMBER,
  ENTER_MAILING_ADDRESS,
  INVALID_MAILING_ADDRESS,
  INVALID_CITY,
  ENTER_MAIL,
  ENTER_CITY,
  ENTER_ZIP_CODE,
  SELECT_STATE,
  INVALID_ZIP_CODE,
  ENTER_VALID_SIGN_UP_CODE,
  ADD_LEGAL_ENTITIES_WITH_ACCOUNTS,
  SELECT_ATLEAST_ONE_PROVIDER,
  ENTER_FIRST_NAME,
  ENTER_ENTITY_NAME,
  INVALID_ENTITY_NAME,
  CONFIRM_INFO_BEFORE_PROCEEDING,
  ERROR_VALIDATING_REGISTRATION_REQUEST,
} from "../../configurations/MessageConstants";
import ConfirmPopUp from "../registrationMap/ConfirmPopup";
import { setRegisteredUserEmail } from "../../configurations/redux-configurations/actions/userAction";
import {
  setInitialFarms,
  setInitialBusiness,
} from "../../configurations/redux-configurations/actions/fieldAction";
import { useDispatch } from "react-redux";
import StorageHelper from "../../helpers/StorageHelper";
import AuthHelper from "../../helpers/AuthHelper";
import UserService from "../../api-service/UserService";
import LoadingOverlay from "../common/LoadingOverlay";
import { Navigate } from "react-router-dom";
import MessageBanner from "../common/MessageBanner";
import { StatusCodes } from "../../configurations/status-codes";

const { FARMER_MOBILE_PREFIX } = config;

function Register() {
  const dispatch = useDispatch();
  const [user, setUser] = useState({
    firstName: EMPTY,
    lastName: EMPTY,
    email: EMPTY,
    confirmEmail: EMPTY,
    phoneNumber: EMPTY,
    confirmPhoneNumber: EMPTY,
    address: EMPTY,
    city: EMPTY,
    state: "Nebraska",
    zipCode: EMPTY,
    signUpCode: EMPTY,
    signUpCodeArray: [EMPTY],
  });
  const [validated, setValidated] = useState(false);
  const [legalEntities, setLegalEntities] = useState([{ name: EMPTY }]);
  const [allPowerProviderChecked, setAllPowerProviderChecked] = useState(false);
  const [powerProviders, setPowerProviders] = useState(ELECTRIC_PROVIDERS_LIST);
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState(EMPTY);
  const [variant, setVariant] = useState(DANGER);
  const [redirect, setRedirect] = useState(false);
  const [overlayLoading, setOverlayLoading] = useState(false);
  const [powerProviderError, setPowerProviderError] = useState(false);
  const [legalEntitiesError, setLegalEntitiesError] = useState(false);
  const [signupCodeError, setSignupCodeError] = useState(false);
  const [emailInvalidError, setEmailInvalidError] = useState(false);
  const [phoneInvalidError, setPhoneInvalidError] = useState(false);
  const [zipCodeError, setZipCodeError] = useState(false);
  const [showProgramInfo, setShowProgramInfo] = useState(false);
  const [noPowerProviders, setNoPowerProviders] = useState(false);
  const [hasPowerProviders, setHasPowerProviders] = useState(false);
  const [skipPhoneVerification, setSkipPhoneVerification] = useState(false);
  const [showConfirmPopUp, setShowConfirmPopUp] = useState(false);

  useEffect(() => {
    (async function () {
      setTimeout(() => {
        document.getElementById("jsd-widget").style.opacity = "0";
      }, 300);
    })();
  }, []);

  const handleOnChange = (e, prevState) => {
    const name = e.target.name;
    const value = e.target.value;
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAddLegalEntities = () => {
    setLegalEntities(legalEntities.concat([{ name: EMPTY }]));
  };

  const handleAddSignUpCodes = () => {
    setUser((prevState) => ({
      ...prevState,
      signUpCodeArray: user.signUpCodeArray.concat([EMPTY]),
    }));
  };

  const handleRemoveLegalEntities = (idx) => () => {
    setLegalEntities(legalEntities.filter((s, sidx) => idx !== sidx));
  };

  const handleRemoveSignUpCodes = (idx) => () => {
    if (user.signUpCodeArray.length === 1) return;
    setUser((prevState) => ({
      ...prevState,
      signUpCodeArray: user.signUpCodeArray.filter((s, sidx) => idx !== sidx),
    }));
  };

  const handleEntityNameChange = (idx) => (evt) => {
    const newlegalEntities = legalEntities.map((entity, sidx) => {
      if (idx !== sidx) return entity;
      return { ...entity, name: evt.target.value };
    });
    setLegalEntities(newlegalEntities);
  };

  const handleSignUpCodeChange = (idx) => (evt) => {
    const newSignUpCodes = user.signUpCodeArray.map((item, sidx) => {
      if (idx !== sidx) return item;
      return evt.target.value;
    });
    setUser((prevState) => ({
      ...prevState,
      signUpCodeArray: newSignUpCodes,
    }));
  };

  const validatePowerProviders = (providers, providerName, checked) => {
    let isInvalid = false;
    let currentPowerProviders = [];

    currentPowerProviders = providers.filter((item) => item.isActive);
    if (currentPowerProviders.length === 1 && checked === false) {
      isInvalid = true;
    } else if (currentPowerProviders.length === 0 && checked === true) {
      isInvalid = false;
    } else if (currentPowerProviders.length >= 1 && checked === true) {
      isInvalid = false;
    } else if (currentPowerProviders.length > 1 && checked === false) {
      isInvalid = false;
    } else {
      isInvalid = true;
    }

    if (providerName === "selectAll" && checked === false) {
      isInvalid = true;
    }
    if (noPowerProviders) {
      isInvalid = true;
    }
    return isInvalid;
  };

  const handleCheckboxChange = (e) => {
    let providerName = e.target.name;
    let checked = e.target.checked;
    let isInvalidState = false;

    isInvalidState = validatePowerProviders(
      powerProviders,
      providerName,
      checked
    );
    if (providerName === "selectAll") {
      setAllPowerProviderChecked(checked);
      setPowerProviders(
        powerProviders.map((item) => ({
          ...item,
          isActive: checked,
        }))
      );
    } else {
      setAllPowerProviderChecked(powerProviders.every((item) => item.isActive));
      setPowerProviders(
        powerProviders.map((item) =>
          item.name === providerName ? { ...item, isActive: checked } : item
        )
      );
    }
    setPowerProviderError(isInvalidState);
    if (noPowerProviders === true) {
      setPowerProviderError(false);
    }
  };

  const validateRegistrationRequest = async () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setShowConfirmPopUp(false);
    setOverlayLoading(true);
    const payload = {
      verification_code: user.signUpCodeArray,
      user_email: user.email.trim().toLowerCase(),
      phone: user.phoneNumber.replace(/\D+/g, EMPTY),
    };
    try {
      const response = await UserService.validateUser(payload);
      const responseJson = response.data;
      setOverlayLoading(false);
      setShowAlert(false);
      setSkipPhoneVerification(responseJson.data.for_staff ? true : false);
      setShowPasswordPopup(!showPasswordPopup);
      FluentdHelper.logEvent(
        `User ${payload.user_email} successfully validated.`,
        "FE_validateRegistrationRequest",
        payload.user_email,
        {
          request: payload,
          response: responseJson,
        }
      );
    } catch (error) {
      let responseData = error.response.data;
      setOverlayLoading(false);
      setShowAlert(showAlert === true ? showAlert : !showAlert);
      setAlertMessage(
        error.response.status === StatusCodes.BAD_REQUEST
          ? responseData.message
          : error.message
      );
      setVariant(DANGER);

      FluentdHelper.logEvent(
        error.response.status === StatusCodes.BAD_REQUEST
          ? responseData.message
          : error.message,
        "FE_validateRegistrationRequest",
        payload.user_email,
        {
          request: payload,
          response:
            error.response.status === StatusCodes.BAD_REQUEST
              ? responseData
              : error,
        },
        LOGERROR
      );

      if (error.response.status === StatusCodes.BAD_REQUEST) {
        if (responseData.message_code === MC004) {
          setSignupCodeError(true);
          setAlertMessage(SIGNUP_CODE_NOT_VALID);
        } else if (
          responseData.message_code === MC003 ||
          responseData.message_code === MC005
        ) {
          setEmailInvalidError(true);
          setAlertMessage(USER_EMAIL_REGISTERED);
        } else if (responseData.message_code === MC006) {
          setPhoneInvalidError(true);
          setAlertMessage(MOBILE_NUMBER_REGISTERED);
        } else {
          setSignupCodeError(true);
          emailInvalidError(true);
          phoneInvalidError(true);
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
        console.error(ERROR_VALIDATING_REGISTRATION_REQUEST, error);
      }
    }
  };
  const validateLegalEntities = (Entities) => {
    const uniqueEntities = [
      ...new Set(Entities.map((e) => Object.values(e)[0].trim().toLowerCase())),
    ];

    if (uniqueEntities.length !== Entities.length) {
      setLegalEntitiesError(true);
      return false;
    } else {
      setLegalEntitiesError(false);
      return true;
    }
  };

  const showProgramInformation = () => {
    let el = document.getElementById("water-info");
    setTimeout(() => {
      el.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }, 300);
  };

  const handleValidateRequest = (event) => {
    let selectedProviders = 0;
    setOverlayLoading(true);
    setSignupCodeError(false);
    setEmailInvalidError(false);
    setPhoneInvalidError(false);
    setLegalEntitiesError(false);
    setZipCodeError(false);

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();

      powerProviders.forEach((p) => {
        if (p.isActive) selectedProviders += 1;
      });

      if (selectedProviders === 0) {
        setPowerProviderError(noPowerProviders === true ? false : true);
      } else {
        setPowerProviderError(false);
      }
      setValidated(true);
      setOverlayLoading(false);
      setShowAlert(showAlert === true ? showAlert : !showAlert);
      setAlertMessage(ENTER_REQUIRED_INFO);
      setVariant(DANGER);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return false;
    } else if (validateLegalEntities(legalEntities) === false) {
      event.preventDefault();
      event.stopPropagation();

      setValidated(true);
      setOverlayLoading(false);
      setShowAlert(showAlert === true ? showAlert : !showAlert);
      setAlertMessage(UNIQUE_ENTITY_NAME);
      setVariant(DANGER);

      window.scrollTo({ top: 0, behavior: "smooth" });
      return false;
    } else if (isNaN(user.zipCode)) {
      event.preventDefault();
      event.stopPropagation();

      setValidated(true);
      setZipCodeError(true);
      setOverlayLoading(false);
      setShowAlert(showAlert === true ? showAlert : !showAlert);
      setAlertMessage("Zip code is invalid");
      setVariant(DANGER);

      window.scrollTo({ top: 0, behavior: "smooth" });
      return false;
    } else if (user.email !== user.confirmEmail) {
      event.preventDefault();
      event.stopPropagation();
      setOverlayLoading(false);
      setShowAlert(true);
      setAlertMessage(EMAIL_NOT_MATCHING_WITH_CONFIRM_EMAIL);
      setVariant(DANGER);

      window.scrollTo({ top: 0, behavior: "smooth" });
      return false;
    } else if (user.phoneNumber !== user.confirmPhoneNumber) {
      event.preventDefault();
      event.stopPropagation();
      setOverlayLoading(false);
      setShowAlert(true);
      setAlertMessage(MOBILE_NUMBER_NOT_MATCHING_WITH_CONFIRM_MOBILE_NUMBER);
      setVariant(DANGER);

      window.scrollTo({ top: 0, behavior: "smooth" });
      return false;
    } else if (user.signUpCodeArray.length === 0) {
      event.preventDefault();
      event.stopPropagation();
      setOverlayLoading(false);
      setShowAlert(true);
      setAlertMessage(SIGNUP_CODE_NEEDED);
      setVariant(DANGER);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return false;
    } else {
      event.preventDefault();
      event.stopPropagation();

      setValidated(false);
      setShowConfirmPopUp(true);
      setOverlayLoading(false);
      setShowAlert(false);
      setAlertMessage(EMPTY);
      setVariant(DANGER);
    }
  };

  const closeWarningPopup = () => {
    setShowConfirmPopUp(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const closeAlert = () => {
    setShowAlert(!showAlert);
    setAlertMessage(EMPTY);
    setVariant(EMPTY);
  };

  const redirectToMap = () => {
    setShowPasswordPopup(false);
    setRedirect(true);
    setOverlayLoading(false);
  };

  const handleRequestSubmit = async (payload) => {
    try {
      const response = await AuthHelper.SignUp(payload);
      FluentdHelper.logEvent(
        `User ${payload.user_email} successfully inserted request.`,
        "FE_handleRequestSubmit",
        payload.user_email,
        {
          request: payload,
          response: response,
        }
      );
      return response;
    } catch (error) {
      let responseData = error.response.data;
      FluentdHelper.logEvent(
        error.response.status === StatusCodes.BAD_REQUEST
          ? responseData.message
          : error.message,
        "FE_handleRequestSubmit",
        payload.user_email,
        {
          request: payload,
          response:
            error.response.status === StatusCodes.BAD_REQUEST
              ? responseData
              : error,
        },
        LOGERROR
      );

      if (error.response.status === StatusCodes.BAD_REQUEST) {
        return responseData;
      } else {
        return {
          data: {
            response: ERROR_CALLING_FUNCTION,
            code: StatusCodes.BAD_REQUEST,
          },
        };
      }
    }
  };

  const closePopUp = (e) => {
    setShowPasswordPopup(false);
    setOverlayLoading(false);
  };

  const handleSubmit = async (event, password) => {
    StorageHelper.setItem(LOGGING_OUT, LOG_OUT + Math.random());
    StorageHelper.removeItem(LOGGING_OUT);
    const Username = user.email.toLowerCase().trim();
    StorageHelper.setItem(REGISTERED_USER, Username);
    dispatch(setRegisteredUserEmail(Username));

    let legalEntitiesValues = legalEntities.map((e) => {
      return Object.values(e)[0];
    });
    const defaultBusiness = user.firstName.trim() + " " + user.lastName.trim();
    let farms = [];
    try {
      if (legalEntitiesValues.length === 0) {
        legalEntitiesValues.push(defaultBusiness);
      } else {
        const regex = new RegExp(legalEntitiesValues.join("|"), "i");
        if (regex.test(defaultBusiness) === false) {
          legalEntitiesValues.push(defaultBusiness);
        }
      }
    } catch {}
    legalEntitiesValues.forEach((entity) => {
      farms.push({ farmName: entity, businessName: entity });
    });
    dispatch(setInitialBusiness(legalEntitiesValues));
    dispatch(setInitialFarms(farms));
    StorageHelper.setItem(SUCCESSFUL_REGISTRATION, true);

    let providers = {};
    powerProviders.forEach((p) => (providers[p.name] = p.isActive));

    const payload = {
      first_name: user.firstName.trim(),
      last_name: user.lastName.trim(),
      user_email: user.email.trim().toLowerCase(),
      prefix: FARMER_MOBILE_PREFIX,
      phone: user.phoneNumber.replace(/\D+/g, EMPTY),
      address: user.address,
      city: user.city,
      state: user.state,
      postal_code: user.zipCode,
      verification_code: user.signUpCodeArray,
      password: password,
      legal_entities: legalEntitiesValues,
      authorized_electric_power_provider: providers,
      for_staff: skipPhoneVerification ? "1" : "0",
      district_id: 1,
    };
    return await handleRequestSubmit(payload);
  };

  const checkPowerProviderValidation = (e, selection) => {
    if (e.target.checked) {
      if (selection === "Yes") {
        setNoPowerProviders(true);
        setPowerProviderError(true);
        setHasPowerProviders(false);
      } else {
        setNoPowerProviders(false);
        setPowerProviderError(false);
        setHasPowerProviders(true);
      }

      setPowerProviders(
        powerProviders.map((item) => ({
          ...item,
          isActive: false,
        }))
      );
      setAllPowerProviderChecked(powerProviders.every((item) => item.isActive));
    } else {
      if (selection === "Yes") {
        let allCheckedPowerProvider = powerProviders.filter(function (item) {
          return item.isActive === true;
        });
        if (allCheckedPowerProvider.length === 0) {
          setPowerProviderError(true);
        }
        setNoPowerProviders(true);
        setHasPowerProviders(false);
      } else {
        setNoPowerProviders(false);
        setPowerProviderError(false);
        setHasPowerProviders(true);
      }
    }
  };

  const handleHide = () => {};

  const renderPowerProvidersList = (selectedPowerProviders) => {
    return powerProviders.map((item, index) => (
      <div key={item.id}>
        <FormText color="muted">
          <Form.Check
            type="checkbox"
            id={"chkpp" + index}
            name={item.name}
            value={item.name}
            checked={item.isActive}
            onChange={handleCheckboxChange}
            label={item.desc}
            disabled={noPowerProviders === true ? false : true}
            required={
              noPowerProviders && selectedPowerProviders.length === 0
                ? true
                : false
            }
          />
        </FormText>
      </div>
    ));
  };

  const { email, confirmEmail, phoneNumber, confirmPhoneNumber } = user;
  let _class = EMPTY;
  let errMessage = EMPTY;
  let _phone_class = EMPTY;
  let errorMessagePhone = EMPTY;
  if (email !== confirmEmail) {
    _class = "is-invalid has-error invalidcontrol";
    errMessage =
      confirmEmail === EMPTY ? ENTER_CONFIRM_EMAIL : EMAIL_DONT_MATCH;
  } else {
    errMessage = ENTER_CONFIRM_EMAIL;
    _class = EMPTY;
  }
  if (phoneNumber !== confirmPhoneNumber) {
    _phone_class =
      "form-control form-control-sm is-invalid has-error invalidcontrol";
    errorMessagePhone =
      confirmPhoneNumber === EMPTY
        ? ENTER_CONFIRM_MOBILE_NUMBER
        : MOBILE_NUMBERS_DONT_MATCH;
  } else {
    errorMessagePhone = ENTER_CONFIRM_MOBILE_NUMBER;
    _phone_class = "form-control form-control-sm ";
  }

  let selectedPowerProviders = [];
  powerProviders.map((p) => {
    if (p.isActive === true) {
      selectedPowerProviders.push(EMPTY);
    }
    return true;
  });

  const alert = [];
  if (redirect) {
    return <Navigate to="/map" />;
  }

  if (showAlert) {
    alert.push(
      <Alert
        key="messageAlert"
        showPasswordPopup={showAlert}
        variant={variant}
        closeAlert={(e) => closeAlert(e)}
        alertMessage={alertMessage}
      />
    );
  }

  return (
    <div>
      <LoadingOverlay
        showSpinner={true}
        active={overlayLoading}
        text="Please wait..."
      />
      <MessageBanner
        title={"TPNRD Water Data Program"}
        description={COMPLETE_REGISTRATION}
      />
      <Form
        className="text-start"
        noValidate
        validated={validated}
        onSubmit={(e) => handleValidateRequest(e)}
        style={{ marginTop: "20px" }}
      >
        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="4" controlId="validationCustomfirstname">
            <Form.Label>First Name*</Form.Label>
            <Form.Control
              size="sm"
              type="text"
              name="firstName"
              onChange={handleOnChange}
              required
              maxLength="40"
              pattern="^[\s]*[A-Za-z]+[\s]*[A-Za-z\s'-]*"
            />
            <Form.Control.Feedback type="invalid">
              {user.firstName === EMPTY ? ENTER_FIRST_NAME : ENTER_ONLY_LETTERS}
            </Form.Control.Feedback>
            <FormText color="muted">
              <p className="text-start register-note">
                Note: The combination of First Name and Last Name will be added
                as an Entity and Farm
              </p>
            </FormText>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="validationCustomlastname">
            <Form.Label>Last Name*</Form.Label>
            <Form.Control
              size="sm"
              onChange={handleOnChange}
              type="text"
              name="lastName"
              required
              maxLength="40"
              pattern="^[\s]*[A-Za-z]+[\s]*[A-Za-z\s'-]*"
            />
            <Form.Control.Feedback type="invalid">
              {user.lastName === EMPTY ? ENTER_LAST_NAME : ENTER_ONLY_LETTERS}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="2"></Form.Group>
        </Row>

        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="4" controlId="validationCustomEmail">
            <Form.Label>Email*</Form.Label>
            <Form.Control
              size="sm"
              type="email"
              name="email"
              maxLength="40"
              onChange={handleOnChange}
              pattern="[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,4}"
              required
              className={emailInvalidError ? "invalidcontrol" : EMPTY}
            />
            <Form.Control.Feedback type="invalid">
              {user.email === EMPTY ? ENTER_MAIL : EMAIL_IS_INVALID}
            </Form.Control.Feedback>
            <FormText color="muted">
              <p className="text-start register-note">
                Note: Email address will also be TPNRD/AgHub username
              </p>
            </FormText>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="validationCustomEmailConfirm">
            <Form.Label>Confirm Email*</Form.Label>
            <Form.Control
              size="sm"
              type="text"
              name="confirmEmail"
              maxLength="40"
              onChange={handleOnChange}
              required
              className={_class}
            />
            <Form.Control.Feedback type="invalid">
              {errMessage}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="2"></Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="4" controlId="validationCustomPhone">
            <Form.Label>Mobile Phone Number*</Form.Label>
            <MaskedInput
              type="text"
              size="sm"
              name="phoneNumber"
              className={
                phoneInvalidError
                  ? "invalidcontrol form-control form-control-sm"
                  : "form-control form-control-sm"
              }
              required
              onChange={handleOnChange}
              pattern="^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$"
              mask={[
                "(",
                /[1-9]/,
                /\d/,
                /\d/,
                ")",
                " ",
                /\d/,
                /\d/,
                /\d/,
                "-",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ]}
            />
            <Form.Control.Feedback type="invalid">
              {user.phoneNumber === EMPTY
                ? ENTER_MOBILE_NUMBER
                : INVALID_MOBILE_NUMBER}
            </Form.Control.Feedback>
            <FormText color="muted">
              <p className="text-start register-note">
                Note: You will receive verification code on your Mobile Phone
                Number
              </p>
            </FormText>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="validationCustomConfirmPhone">
            <Form.Label>Confirm Mobile Phone Number*</Form.Label>
            <MaskedInput
              type="text"
              size="sm"
              name="confirmPhoneNumber"
              required
              onChange={handleOnChange}
              pattern="^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$"
              mask={[
                "(",
                /[1-9]/,
                /\d/,
                /\d/,
                ")",
                " ",
                /\d/,
                /\d/,
                /\d/,
                "-",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ]}
              className={_phone_class}
            />
            <Form.Control.Feedback type="invalid">
              {errorMessagePhone}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="2"></Form.Group>
        </Row>

        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="8" controlId="validationCustomAddress">
            <Form.Label>Mailing Address*</Form.Label>
            <Form.Control
              size="sm"
              type="text"
              onChange={handleOnChange}
              name="address"
              required
              maxLength="60"
              pattern="(.|\s)*\S(.|\s)*"
            />
            <Form.Control.Feedback type="invalid">
              {user.address === EMPTY
                ? ENTER_MAILING_ADDRESS
                : INVALID_MAILING_ADDRESS}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group as={Col} md="2"></Form.Group>
        </Row>

        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="3" controlId="validationCustomCity">
            <Form.Label>City*</Form.Label>
            <Form.Control
              size="sm"
              type="text"
              name="city"
              onChange={handleOnChange}
              required
              maxLength="40"
              pattern="(.|\s)*\S(.|\s)*"
            />
            <Form.Control.Feedback type="invalid">
              {user.city === EMPTY ? ENTER_CITY : INVALID_CITY}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="3" controlId="validationCustomState">
            <Form.Label>State*</Form.Label>
            <Form.Select
              size="sm"
              defaultValue="Nebraska"
              name="state"
              onChange={handleOnChange}
              required
              placeholder="Select State"
            >
              {STATES.map((item) => (
                <option value={item} key={item}>
                  {item}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {SELECT_STATE}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="2" controlId="validationCustomZipCode">
            <Form.Label>Zip Code*</Form.Label>
            <Form.Control
              size="sm"
              type="text"
              name="zipCode"
              onChange={handleOnChange}
              required
              maxLength="10"
              pattern="^[0-9]*"
              className={zipCodeError ? "invalidcontrol" : EMPTY}
            />
            <Form.Control.Feedback type="invalid">
              {user.zipCode === EMPTY ? ENTER_ZIP_CODE : INVALID_ZIP_CODE}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group as={Col} md="2"></Form.Group>
        </Row>

        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="5" controlId="validationCustomsignupcode">
            <br></br>
            <p>
              <Button
                type="button"
                size="sm"
                className="small"
                title="Add Entities"
                onClick={handleAddSignUpCodes}
              >
                Add Sign Up Codes
              </Button>
            </p>

            {user.signUpCodeArray.map((item, idx) => (
              <div key={idx} className="mb-2">
                <Row>
                  <Form.Group as={Col} md="10">
                    <Form.Control
                      size="sm"
                      type="text"
                      maxLength="40"
                      value={item.code}
                      onChange={handleSignUpCodeChange(idx)}
                      placeholder={EMPTY}
                      required
                      className={signupCodeError ? "invalidcontrol" : EMPTY}
                    />
                    <Form.Control.Feedback type="invalid">
                      {ENTER_VALID_SIGN_UP_CODE}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="2">
                    <Button
                      size="sm"
                      className="pt-1 pb-1"
                      onClick={handleRemoveSignUpCodes(idx)}
                    >
                      X
                    </Button>
                  </Form.Group>
                </Row>
              </div>
            ))}
            <FormText color="muted">
              <p className="text-start register-note">
                Note: If you don’t have a Sign-Up Code, please call Twin Platte
                NRD at (308) 535-8080
              </p>
            </FormText>
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="8">
            <Form.Label>
              Farm Operation - Legal Entities
              <FormText color="muted">
                <p className="text-start">
                  {ADD_LEGAL_ENTITIES_WITH_ACCOUNTS} If this does not apply to
                  you and you do not use a legal entity in your farming
                  business, please click the “X” button to the right of the text
                  box below.
                </p>
              </FormText>
            </Form.Label>
            <br />
            <p>
              <Button
                type="button"
                size="sm"
                className="small"
                title="Add Entities"
                onClick={handleAddLegalEntities}
              >
                Add Entities
              </Button>
            </p>

            {legalEntities.map((entity, idx) => (
              <div key={idx} className="mb-2">
                <Row>
                  <Form.Group as={Col} md="10">
                    <Form.Control
                      size="sm"
                      type="text"
                      maxLength="40"
                      value={entity.name}
                      onChange={handleEntityNameChange(idx)}
                      placeholder={EMPTY}
                      required
                      className={legalEntitiesError ? "invalidcontrol" : EMPTY}
                      pattern="(.|\s)*\S(.|\s)*"
                    />
                    <Form.Control.Feedback type="invalid">
                      {entity.name === EMPTY
                        ? ENTER_ENTITY_NAME
                        : INVALID_ENTITY_NAME}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="2">
                    <Button
                      size="sm"
                      className="pt-1 pb-1"
                      onClick={handleRemoveLegalEntities(idx)}
                    >
                      X
                    </Button>
                  </Form.Group>
                </Row>
              </div>
            ))}
          </Form.Group>
        </Row>

        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="10">
            <Form.Label>
              <h3>Permissions and Consents</h3>
            </Form.Label>
          </Form.Group>
        </Row>

        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="8">
            <div className="h-divider"></div>
          </Form.Group>
        </Row>

        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="8" className="mb-0">
            <Form.Label>
              <strong>
                Consent to AgHub Terms and Conditions & GiSC Membership
                Agreement*
              </strong>
            </Form.Label>
          </Form.Group>
        </Row>

        <Row className="ps-3">
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="8" controlId="validationCustomsaghubterm">
            <FormText color="muted">
              <Form.Check
                required
                name="aghubterm"
                label={
                  <div>
                    I agree to the&nbsp;
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.gisc.cloud/terms-of-service/"
                    >
                      AgHub Terms and Conditions
                    </a>
                    &nbsp;and the&nbsp;
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.gisc.cloud/wp-content/uploads/2019/01/GiSC-Membership-Agreement_Jan-15-2019.pdf"
                    >
                      GiSC Membership Agreement
                    </a>
                  </div>
                }
                id="agreeTerm"
              />
            </FormText>
          </Form.Group>
        </Row>

        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="8" className="mb-0">
            <Form.Label>
              <strong>Electric Power Provider Authorization*</strong>
            </Form.Label>
          </Form.Group>
        </Row>

        <Row className="ps-3">
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group
            as={Col}
            md="8"
            controlId="validationCustomspowerproviderterm"
          >
            <FormText color="muted">
              <Form.Check
                required={hasPowerProviders ? false : true}
                name="terms"
                label="I hereby give the Electric Power Providers selected below permission to release my electric data to Twin Platte NRD & GiSC"
                id="providerTerm"
                checked={noPowerProviders ? true : false}
                onChange={(e) => checkPowerProviderValidation(e, "Yes")}
              />
            </FormText>
          </Form.Group>
        </Row>
        <Row className="ps-3">
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group
            as={Col}
            md="8"
            controlId="validationCustomsnopowerproviderterm"
          >
            <FormText color="muted">
              <Form.Check
                required={noPowerProviders ? false : true}
                name="terms"
                label="I do not have any registered wells with electric power in the Twin Platte NRD"
                id="noProviderTerm"
                checked={hasPowerProviders ? true : false}
                onChange={(e) => checkPowerProviderValidation(e, "No")}
              />
            </FormText>
          </Form.Group>
        </Row>

        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="8" className="mb-0">
            <Form.Label>
              <strong>
                Authorized Electric Power Provider
                {noPowerProviders ? "*" : EMPTY}
              </strong>
            </Form.Label>
          </Form.Group>
        </Row>

        <Row className="ps-3">
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="8">
            <FormText color="muted">
              <strong>
                <Form.Check
                  id="selectAll"
                  type="checkbox"
                  required={
                    noPowerProviders === true &&
                    selectedPowerProviders.length === 0
                      ? true
                      : false
                  }
                  disabled={noPowerProviders === true ? false : true}
                  name="selectAll"
                  checked={allPowerProviderChecked}
                  feedback={SELECT_ATLEAST_ONE_PROVIDER}
                  isInvalid={
                    noPowerProviders === false ? false : powerProviderError
                  }
                  onChange={handleCheckboxChange}
                  label="Select All"
                />
              </strong>
              {renderPowerProvidersList(selectedPowerProviders)}
            </FormText>
          </Form.Group>
        </Row>

        <Row>
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="8" className="mb-0">
            <Form.Label>
              <strong>
                Consent to Release Water Usage Data to Twin Platte NRD*
              </strong>
            </Form.Label>
          </Form.Group>
        </Row>

        <Row className="ps-3">
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="8" controlId="validationCustomwaterterm">
            <FormText color="muted">
              <Form.Check
                required
                name="terms3"
                label="I hereby consent to the release of my irrigation water use data by GiSC to Twin Platte NRD"
                id="waterterm"
              />
            </FormText>
          </Form.Group>
        </Row>

        <Row className="mt-2 mb-3">
          <Form.Group as={Col} md="2"></Form.Group>
          <Form.Group as={Col} md="4">
            <Button type="submit">Next</Button>

            <Button
              variant="link"
              className="ms-3 link btn btn-more"
              onClick={() => {
                setShowProgramInfo(!showProgramInfo);
                showProgramInformation();
              }}
              aria-controls="example-collapse-text"
              aria-expanded={showProgramInfo}
            >
              <span className="text-blue cursor-pointer">
                {showProgramInfo ? "Hide" : "Learn More"}
              </span>
            </Button>
          </Form.Group>
        </Row>
        <PasswordPopUp
          onHide={handleHide()}
          showPasswordPopup={showPasswordPopup}
          userEmail={user.email.toLowerCase().trim()}
          userPhone={user.phoneNumber}
          closeModal={(e) => closePopUp(e)}
          onSubmit={(e, password) => handleSubmit(e, password)}
          onVerified={(e) => redirectToMap()}
          skipPhoneVerification={skipPhoneVerification}
        />
        {showConfirmPopUp && (
          <ConfirmPopUp
            showConfirmPopup={showConfirmPopUp}
            message={CONFIRM_INFO_BEFORE_PROCEEDING}
            addedFieldStatus={0}
            closeWarningPopup={(e) => closeWarningPopup(e)}
            performWarningAction={(e) => validateRegistrationRequest()}
            header={"Are you sure?"}
            tpId={EMPTY}
            noActionRequired={true}
            cancelButton={"Cancel"}
            confirmButton={"Confirm"}
          />
        )}
      </Form>
      <Collapse in={showProgramInfo} id="water-info">
        <div>
          <div className="register-info-heading">
            <h2 className="text-center">
              What is the TPNRD Water Data Program?
            </h2>
          </div>
          <Container className="w-75">
            <Row>
              <Col md="3" className="d-flex align-items-center">
                <img src={gisc_logo} className="img-fluid" alt="Logo" />
              </Col>
              <Col md="6">
                <img src={tpunit_logo} className="img-fluid" alt="Logo" />
              </Col>
              <Col md="3" className="d-flex align-items-center">
                <img src={tpnrd_logo} className="img-fluid" alt="Logo" />
              </Col>
            </Row>
            <p>
              Twin Platte Natural Resources District (TPNRD) has entered into an
              agreement with GiSC for collecting water use. GiSC is a
              producer-owned data cooperative and is governed by a board of
              farmers. Together, TPNRD and its producers have partnered with
              GiSC to bring TPNRD Irrigated Growers a new Water Data Program.
              This program will be an evolving digital service that automates
              the collection of higher quality water usage data.
            </p>
            <p>
              GiSC’s digital platform will be the foundation of the Water Data
              Program, and will collect and store water usage data based on four
              key pieces of information:
            </p>
            <ul>
              <li>Your Acres</li>
              <li>Crops Planted</li>
              <li>Well Flow</li>
              <li>Hours of Pumping</li>
            </ul>
            <p>
              The expected outcome is a more accurate model of our water
              resources and that is to your advantage. TPNRD is committed to
              serving you by making sure we are utilizing the best data.
            </p>
            <p>
              Along with the prospect of productivity gains in farming
              operations, the Water Data Program will also generate the data
              needed for the required ground water models utilized in the TPNRD
              Integrated Management Plan (IMP). The IMP is a required plan for
              the TPNRD to manage water over the next 10 years.
            </p>
            <p>
              Any questions? Please call Twin Platte NRD or Ann Dimmitt at (308)
              535-8080
            </p>
          </Container>
        </div>
      </Collapse>
    </div>
  );
}

export default Register;
